import { FieldProps, InputProps, useField } from 'informed';
import { useEffect } from 'react';
import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';
import { InputWrapper, InputWrapperProps } from '../common';

interface TyInputNumberProps extends InputProps, Omit<InputWrapperProps, 'icon' | 'suffix'> {
}

export const TyNumberInput = (props: FieldProps<TyInputNumberProps, number, object>) => {
  const innerProps: typeof props = { defaultValue: 0, ...props };
  const { render, userProps, ref, fieldState, fieldApi } = useField(innerProps);
  const { setValue, setTouched, setFocused } = fieldApi;
  const { maskedValue, showError, error } = fieldState;
  const { label, id, className, simple, description, ...rest } = userProps;

  // min values allowed if not set and not zero use -Infinity
  const min = Number(rest.min) || Number(rest.min) === 0 ? Number(rest.min) : -Infinity;
  const max = Number(rest.max) || Number(rest.max) === 0 ? Number(rest.max) : Infinity;

  useEffect(() => {
    ref.current.setCustomValidity(error || '');
  }, [error, ref]);

  const stepUp = () => {
    setValue(Math.max(min, Math.min(max, Number(maskedValue||0) + 1)));
  }
  const stepDown = () => {
    setValue(Math.max(min, Math.min(max, Number(maskedValue||0) - 1)));
  }

  return render(
    <InputWrapper
      className={className}
      simple={simple}
      label={label}
      error={showError ? String(error) : undefined}
      description={description}
    >
      <div className="flex flex-1 !m-0">
        <input
          ref={ref}
          id={id}
          {...rest}
          type="text"
          className="text-center peer order-2"
          value={!maskedValue && (maskedValue !== 0 || ref.current?.value === '') ? '' : maskedValue}
          onChange={(e) => {
            if (e.target.value === '') {
              setValue(0);
            } else if (!Number.isNaN(Number(e.target.value))) {
              setValue(Math.max(min, Math.min(max, Number(e.target.value))));
            }
          }}
          onBlur={(e) => {
            if (!e.target.value) {
              e.target.value = String(maskedValue);
            }
            setTouched(true);
          }}
          onFocus={() => {
            setFocused(true);
          }}
        />
        <button type="button" className="m-1 p-1.5 order-1 bg-secondary-50 text-secondary-400 peer-disabled:text-secondary-300 size-8 rounded-md text-center align-middle" onClick={stepDown}><ActionIcon name="minimize" className="size-5" /></button>
        <button type="button" className="m-1 p-1.5 order-3 bg-secondary-50 text-secondary-400 peer-disabled:text-secondary-300 size-8 rounded-md text-center align-middle" onClick={stepUp}><FavouriteIcon name="add" className="size-5" /></button>
      </div>
    </InputWrapper>
  );
};
